// import React, { useEffect, useState } from "react";
// import {
//   Modal,
//   ModalBody,
//   ModalFooter,
//   ModalHeader,
//   FormGroup,
//   Label,
//   Input,
//   Button,
//   Col,
//   Row,
//   Card,
//   CardBody,
// } from "reactstrap";
// import { Link } from "react-router-dom";
// import Dropzone from "react-dropzone";
// import toast from "react-hot-toast";
// import DocumentServices from "../../../services/COOPServices/DocumentServices";
// import { useFormik } from "formik";
// import CustomInput from "../../../Components/Common/CustomInput/CustomInput";
// import axios from "axios";

// const ViewDocuments = ({ isOpen, toggle, selectedDocument, documentId }) => {
//   console.log("🚀 ~ EditDocument ~ documentId:", documentId);
//   const [selectedFiles, setSelectedFiles] = useState([]);
//   const [data, setData] = useState([]);
//   const userString = localStorage.getItem("user");

//   const user = JSON.parse(userString);

//   const token = user.accessToken;

//   console.log("Access Token:", token);

//   console.log("🚀 ~ user:", user);

//   useEffect(() => {
//     (async () => {
//       try {
//         const response = await DocumentServices.getById(documentId);
//         console.log("response dcoumnt id:", response);
//         setData(response);
//       } catch (error) {
//         console.log("🚀 ~ async docId  ~ error:", error);
//       }
//     })();
//   }, [documentId]);

//   return (
//     <Modal isOpen={isOpen} toggle={toggle} style={{ padding: "25px" }} centered>
//       <h4
//         onClick={toggle}
//         className="text-end pt-2 cursor-pointer"
//         style={{ paddingRight: "5px" }}
//       >
//         <i className="bx bx-x"></i>
//       </h4>
//       <h3 className="text-center fw-semi-bold fs-15">View Document</h3>

//       <Card>
//         <CardBody>
//           <div>
//             <div className="d-flex align-items-center mb-0 ">
//               <div className="flex-grow-1 pt-2">
//                 {/* <label className="fw-bold">Name:</label> */}
//                 <span className="fs-8">{data?.name}</span>
//               </div>
//             </div>
//             <div className="d-flex align-items-center mb-1">
//               <div className="flex-grow-1">
//                 <span style={{ fontSize: "12px" }} className="text-muted ">
//                   {data?.title}
//                 </span>
//               </div>
//             </div>
//             <div style={{ fontSize: "12px" }} className="py-1 text-muted">
//               {data.description}
//             </div>
//             <img
//               height="100"
//               className="avatar-sm rounded bg-light"
//               src={`data:image/png;base64,${data.file}`}
//               alt="Document"
//             />
//           </div>
//         </CardBody>
//       </Card>
//     </Modal>
//   );
// };

// export default ViewDocuments;

import React, { useEffect, useState } from "react";
import { Modal, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import DocumentServices from "../../../services/COOPServices/DocumentServices";
import * as XLSX from "xlsx";

const ViewDocuments = ({ isOpen, toggle, documentId }) => {
  const [data, setData] = useState({});
  const userString = localStorage.getItem("user");
  const user = JSON.parse(userString);
  const token = user.accessToken;
  const [categoryId, setCategoryId] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await DocumentServices.getById(documentId);
        setData(response);
      } catch (error) {
        console.log("Error fetching document:", error);
      }
    };
    fetchData();
  }, [documentId]);

  useEffect(() => {
    (async () => {
      try {
        const response = await DocumentServices.getlist();
        const responseCategoryId = response.find(
          (category) => category.id === data.categoryId
        );
        // console.log("response", responseCategoryId);
        console.log("reponse category id:", responseCategoryId);
        setCategoryId(responseCategoryId);
      } catch (error) {
        console.log("🚀 ~ async ~ error:", error);
      }
    })();
  }, []);

  const openPDFInNewTab = (base64PDF) => {
    const byteCharacters = atob(base64PDF);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  };

  const renderFilePreview = (file, extension) => {
    const [excelData, setExcelData] = useState(null);
    if (file) {
      const fileType = extension;
      // console.log("File Type:", fileType);
      if (fileType === ".png" || fileType === ".jpg" || fileType === ".jpeg") {
        const imageFile = `data:image/${fileType.slice(1)};base64,${file}`;
        // console.log("image file->", imageFile);
        const openImageInNewTab = (imageData) => {
          const byteCharacters = atob(imageData.split(",")[1]);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "image/jpeg" });

          // Create a URL for the Blob and open it in a new tab
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl, "_blank");
        };

        return (
          <span className="d-flex justify-content-center ">
            <img
              height="100"
              className="avatar-xm rounded bg-light cursor-pointer"
              src={imageFile}
              alt="Document"
              onClick={() => openImageInNewTab(imageFile)}
            />
          </span>
        );
      } else if (fileType === ".pdf") {
        return (
          <div className="text-center">
            <div
              className="profile-user position-relative d-inline-block mx-auto mb-4 cursor-pointer"
              onClick={() => {
                const pdfWindow = window.open("");
                pdfWindow.document.write(
                  `<iframe width='100%' height='100%' src='data:application/pdf;base64,${file}'></iframe>`
                );
              }}
            >
              <img
                src="/pdfImage.jpeg"
                className="avatar-sm"
                alt="user-profile"
              />
              <p className="text-muted fs-15">Click to view PDF</p>
            </div>
          </div>
        );
      } else if (
        fileType === ".xlsx" ||
        fileType === ".xls" ||
        fileType === ".csv"
      ) {
        const openExcelInNewTabAndDownload = (excelData) => {
          // Decode base64 data
          const byteCharacters = atob(excelData);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          // Open the Excel file in a new tab
          const reader = new FileReader();
          reader.onload = (e) => {
            const data = e.target.result;
            const workbook = XLSX.read(data, { type: "binary" });

            const sheetNames = workbook.SheetNames;
            const firstSheet = workbook.Sheets[sheetNames[0]];
            const jsonData = XLSX.utils.sheet_to_json(firstSheet);
            setExcelData(jsonData);

            const htmlString = XLSX.utils.sheet_to_html(firstSheet);
            const newWindow = window.open("", "_blank");
            newWindow.document.write(htmlString);
          };
          reader.readAsBinaryString(blob);

          // Download the Excel file
          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(blob);
          downloadLink.download = "Document-file.xlsx"; // Set default file name
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        };

        return (
          <div className="text-center">
            <div
              className="profile-user position-relative d-inline-block mx-auto mb-4 cursor-pointer"
              onClick={() => openExcelInNewTabAndDownload(file)}
            >
              <img
                src="/excelImage.png"
                className="avatar-sm"
                alt="user-profile"
              />
              <p className="text-muted fs-15">Click to view Excel file</p>
            </div>
          </div>
        );
      } else {
        return <p>Cannot preview this file type</p>;
      }
    }
    return null;
  };
  // console.log("name", categoryId.name);
  return (
    <Modal isOpen={isOpen} toggle={toggle} style={{ padding: "25px" }} centered>
      <h4
        onClick={toggle}
        className="text-end pt-2 cursor-pointer"
        style={{ paddingRight: "5px" }}
      >
        <i className="bx bx-x"></i>
      </h4>
      <h3 className="text-center fw-semi-bold fs-18">View Document</h3>

      <Card>
        <CardBody>
          <div>
            <div className="d-flex align-items-center mb-0 ">
              <div className="flex-grow-1 pt-2">
                <span className="fs-10">{data?.name}</span>
              </div>
            </div>
            <div className="d-flex align-items-center mb-1">
              <div className="flex-grow-1">
                <span style={{ fontSize: "16px" }} className="text-muted">
                  {data?.title}
                </span>
              </div>
            </div>
            <div style={{ fontSize: "14px" }} className="py-1 text-muted">
              {data.description}
            </div>
            <div style={{ fontSize: "14px" }} className="py-1 text-muted">
              {categoryId?.name}
            </div>
            {renderFilePreview(data.file, data.extension)}
          </div>
        </CardBody>
      </Card>
    </Modal>
  );
};

export default ViewDocuments;
